import { useUrlImageQuery } from "@/query/urlImageQuery"
import { ImageIcon } from "lucide-react"
import { Skeleton } from "../ui/skeleton"

type DisplayLogoProps = {
  urlLogo?: string
  shopName: string
  className?: string
  size?: "small" | "medium" | "large"
}

export const DisplayLogo = ({
  urlLogo,
  shopName,
  className,
  size = "large",
}: DisplayLogoProps) => {
  const {
    urlImage: logoUrl,
    pendingUrlImage: pendingLogo,
    errorUrlImage: errorLogo,
  } = useUrlImageQuery(urlLogo || "")

  if (!urlLogo) {
    return null // Ou un placeholder si vous préférez
  }

  if (pendingLogo) {
    return <Skeleton className={`w-24 h-24 ${className}`} />
  }

  if (errorLogo) {
    return (
      <div className={`w-24 h-24 ${className}`}>
        <ImageIcon className="w-10 h-10" />
      </div>
    )
  }

  return (
    <img
      width={size === "small" ? 32 : size === "medium" ? 64 : 128}
      height={size === "small" ? 32 : size === "medium" ? 64 : 128}
      src={logoUrl}
      alt={`Logo de ${shopName}`}
      className={`object-cover rounded-full border-2 border-slate-300 dark:border-slate-600 p-1 bg-white shadow-md ${className}`}
    />
  )
}
